module.exports = __webpack_public_path__ + "static/media/resume.34b3d3c6.pdf";